import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import FlowKraftWebsite from "./FlowKraftWebsite";
import DeveloppementWeb from "./pages/DeveloppementWeb";
import DeveloppementMobile from "./pages/DeveloppementMobile";
import DesignUXUI from "./pages/DesignUXUI";
import MarketingDigital from "./pages/MarketingDigital";
import Consulting from "./pages/Consulting";
import SolutionsMetier from "./pages/SolutionsMetier";
import MentionsLegales from "./pages/MentionsLegales";
import PolitiqueConfidentialite from "./pages/PolitiqueConfidentialite";
import CGV from "./pages/CGV";
import Portfolio from "./pages/Portfolio";
import "./index.css";

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/" element={<FlowKraftWebsite />} />
          <Route
            path="/services/developpement-web"
            element={<DeveloppementWeb />}
          />
          <Route
            path="/services/developpement-mobile"
            element={<DeveloppementMobile />}
          />
          <Route path="/services/design-ux-ui" element={<DesignUXUI />} />
          <Route
            path="/services/marketing-digital"
            element={<MarketingDigital />}
          />
          <Route path="/services/consulting" element={<Consulting />} />
          <Route path="/services/solutions-metier" element={<SolutionsMetier />} />
          <Route path="/mentions-legales" element={<MentionsLegales />} />
          <Route path="/politique-confidentialite" element={<PolitiqueConfidentialite />} />
          <Route path="/cgv" element={<CGV />} />
          <Route path="/portfolio" element={<Portfolio />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
